module.exports = __webpack_public_path__ + "img/balloon.0a1f6d5a.svg";